/* Spanish catalog mirroring locale-investment-inbox-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'investments.inboxTitle': 'Bandeja de entrada',
  'investments.inboxIntro': 'Sube documentos de compras y ventas de fondos y acciones. Plumme lee el documento y prepara el registro.',
  'investments.supportNotice': 'Los fondos y las acciones son totalmente compatibles para el registro y la contabilización. Otros tipos de inversión pueden reconocerse, pero por ahora requieren gestión manual.',
  'investments.sendToEmail': 'Enviar a',
  'investments.copyEmail': 'Copiar dirección de correo',
  'investments.folder': 'Carpeta',
  'investments.inboxFolder': 'Bandeja de entrada',
  'investments.trashFolder': 'Papelera',
  'investments.documentationFolder': 'Documentación',
  'investments.searchDocuments': 'Buscar documentos',
  'investments.emptyFolder': 'No hay documentos en esta carpeta.',
  'investments.documentNotAnalyzed': 'Listo para analizar',
  'investments.superPlummaProposal': 'Sugerencia de SuperPlumma',
  'investments.reviewAndApprove': 'Revisar y aprobar',
  'investments.notAnalyzedHelp': 'El documento se ha recibido y está listo para analizar.',
  'investments.restoreDocument': 'Restaurar',
  'investments.sendToDocumentation': 'Enviar a documentación',
  'investments.moveToTrash': 'Mover a la papelera',
  'investments.moreActions': 'Más acciones',
  'investments.registerPurchase': 'Registrar compra',
  'investments.registerSale': 'Registrar venta',
  'investments.tradeDate': 'Fecha de operación',
  'investments.unitPrice': 'Valor liquidativo / precio',
  'investments.previewDocumentFallback': 'Documento',
  'investments.previewMissingFileLink': 'Falta el enlace al archivo',
  'investments.openDocument': 'Abrir documento',
  'investments.addBankAccount': '+ Añadir cuenta bancaria …',
  'investments.addBankTitle': 'Añadir cuenta bancaria',
  'investments.addBankSave': 'Añadir cuenta',
  'investments.newBankAccountNote': 'Se crea una nueva cuenta bancaria en el plan de cuentas',
  'investments.newBankAccountCode': 'La cuenta bancaria recibe la siguiente cuenta disponible de la serie 192x: {{code}}.',
  'investments.bankName': 'Nombre de la cuenta',
  'investments.bankNamePlaceholder': 'Por ejemplo, Cuenta de inversión',
  'investments.bankAccountNumber': 'Número de cuenta',
  'investments.openingBalance': 'Saldo de apertura',
  'investments.openingBalanceDate': 'Fecha del saldo de apertura',
  'investments.bankNameRequired': 'Ponle un nombre a la cuenta bancaria.',
  'investments.bankNumberRequired': 'Introduce el número de cuenta.',
  'investments.bankOpeningRequired': 'Introduce un saldo de apertura y una fecha. Introduce 0 si el saldo era cero.',
  'investments.bankNumberExists': 'La cuenta bancaria ya está registrada.',
  'investments.bankLedgerSeriesFull': 'No hay ninguna cuenta disponible en la serie 192x. Añade la cuenta en Ajustes.',
  'investments.bankAdded': 'Cuenta bancaria añadida.',
  'investments.addBankFailed': 'No se pudo añadir la cuenta bancaria.',
  'investments.addBankUnavailable': 'Las cuentas bancarias no están conectadas al backend.',
  'investments.addBankUnsupportedCountry': 'Este flujo de cuentas bancarias solo admite empresas noruegas por ahora.',
  'investments.newInvestmentAccount': 'Nueva cuenta de inversión',
  'investments.investmentAccounts': 'Cuentas de inversión y cuentas de custodia',
  'investments.settingsTab': 'Inversiones',
  'investments.settingsTitle': 'Cuentas de inversión y cuentas de custodia',
  'investments.settingsHelp': 'Gestiona las cuentas mantenidas en bancos, gestoras de fondos y otros proveedores.',
  'investments.editInvestmentAccount': 'Editar cuenta de inversión',
  'investments.investmentAccountsHelp': 'Registra cada cuenta de proveedor. El mismo instrumento puede mantenerse en varias cuentas de custodia mientras la cuenta del libro mayor sigue teniendo cuatro dígitos.',
  'investments.noInvestmentAccounts': 'Todavía no se ha registrado ninguna cuenta de inversión.',
  'investments.saveInvestmentAccount': 'Guardar cuenta de inversión',
  'investments.investmentAccountId': 'Cuenta bancaria / de custodia',
  'investments.targetInvestmentAccountId': 'Nueva cuenta bancaria / de custodia',
  'investments.accountNumber': 'Número de cuenta o de custodia (opcional)',
  'investments.defaultSettlementAccount': 'Cuenta de liquidación predeterminada',
  'investments.noDefaultSettlementAccount': 'Sin cuenta de liquidación predeterminada',
  'investments.accountActive': 'La cuenta de inversión está activa',
  'investments.custody': 'Cuenta de custodia de valores',
  'investments.fund_account': 'Cuenta de fondos',
  'investments.other': 'Otra cuenta de inversión',
  'investments.subledgerCode': 'Número interno de inversión',
  'investments.createInstrumentFromDocument': '{{name}} (se crea al guardar)',
  'investments.providerHelp': 'Dónde se mantiene la inversión, por ejemplo Storebrand o Nordnet. Incluye el número de la cuenta de custodia cuando corresponda.',
  'investments.settlementAccountHelp': 'La cuenta de la empresa que se carga o se abona. Una cuenta de efectivo del proveedor debe registrarse como cuenta bancaria/de liquidación independiente en Ajustes. Una sociedad limitada no puede usar una cuenta personal de ahorro en acciones (ASK).',
  'investments.investmentAccountInvalid': 'Comprueba el nombre, el proveedor y el tipo de cuenta.',
  'investments.investmentAccountNotFound': 'No se encontró la cuenta de inversión o está inactiva.',
  'investments.investmentAccountDuplicate': 'Ya existe una cuenta de inversión con el mismo nombre.',
  'investments.investmentAccountRequired': 'Selecciona una cuenta de inversión cuando el proveedor tenga varias cuentas.',
  'investments.investmentAccountQuantityInvalid': 'La cuenta de custodia seleccionada no tiene suficientes participaciones registradas para este evento.',
});
